﻿
import $ from 'jquery';

declare global {
  interface JQuery {
    autosave: (option) => any;
  }
}

export class Autosave {
  public static get wireup(): string { return '[data-autosave]'; }

  private DEFAULTS: IAutosaveOptions = {
    timeout: 3000,
    autosaveOn: null,
    autosaveOnTargets: null
  };

  private $element: JQuery;
  private timeout: number;
  private options: IAutosaveOptions;
  private isRemoting: boolean;

  private get hasUnsavedChanges(): boolean { return this.timeout != null; }

  constructor($element: JQuery, options: IAutosaveOptions) {
    if (!$element && $element.length != 1)
      throw new Error('You must provide a single element to Rustig.Autosave');
    this.$element = $element;

    this.options = $.extend({}, this.DEFAULTS, $element.data(), options);
    this.$element.on(this.options.autosaveOn, this.options.autosaveOnTargets, this.autosave.bind(this))
      .on('ajaxcomplete.rustig.remote', () => this.isRemoting = false);
    this.setShowAlertIfNavigatingFromPageWithUnsavedChanges();
  }

  public clearAutosaveDebounce(): void {
    clearTimeout(this.timeout);
    this.timeout = null;
  }

  public save(): void {
    this.$element.remote({
      beforeRemote: () => this.isRemoting = true
    });
    this.clearAutosaveDebounce();
  }

  private autosave(event: Event): void {
    if (!this.isRemoting) {
      this.clearAutosaveDebounce();
      this.timeout = window.setTimeout(this.save.bind(this), this.options.timeout);
    }
  }

  private setShowAlertIfNavigatingFromPageWithUnsavedChanges(): void {
    $(window).off('beforeunload.rustig.autosave')
      .on('beforeunload.rustig.autosave', () => {
        if (this.hasUnsavedChanges)
          return 'There are unsaved changes'
      });
  }
}

export interface IAutosaveOptions {
  timeout: number;
  autosaveOn: string;
  autosaveOnTargets: string
}

function Plugin(option) {
  return this.each(function () {
    let $this = $(this);
    let data = $this.data('rustig.autosave');
    let options = typeof option == 'object' && option;

    if (!data) {
      data = new Autosave($this, options);
      $this.data('rustig.autosave', data);
    }
    if (typeof option == 'string')
      data[option]();
  });
}

$.fn.autosave = Plugin;